import Client from './Client';

export type GitlabOauthStatus = {
    configured: boolean;
    connected: boolean;
    username: string | null;
    host: string | null;
};

class GitlabOauth extends Client {
    getStatus() {
        return this.GET('/gitlab-oauth/status')
            .then(async (response) => {
                const json = await response.json();
                if (!response.ok)
                    throw new Error(json.err || 'Failed to load GitLab OAuth status');
                return json as GitlabOauthStatus;
            });
    }

    start(returnTo?: string) {
        const query = returnTo ? `?return_to=${encodeURIComponent(returnTo)}` : '';
        return this.GET(`/gitlab-oauth/start${query}`)
            .then(async (response) => {
                const json = await response.json();
                if (!response.ok)
                    throw new Error(json.err || 'Failed to start GitLab OAuth');
                return json as { url: string };
            });
    }

    disconnect() {
        return this.DELETE('/gitlab-oauth')
            .then(async (response) => {
                const json = await response.json();
                if (!response.ok)
                    throw new Error(json.err || 'Failed to disconnect GitLab OAuth');
                return json as { connected: boolean };
            });
    }
}

const GitlabOauthApi = new GitlabOauth();
export default GitlabOauthApi;
